/**
 * FEAT-108 / S-436 — the invite form's workspace selection.
 *
 * The selection is kept in the order the boxes were ticked: the first one
 * is where the invitee lands (POST /invitations, `agencyclient_ids[0]`).
 */

/** Tick or untick `id`, keeping the remaining ticks in their order. */
export function toggleInOrder(selected: readonly number[], id: number): number[] {
  return selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id];
}

/**
 * Names for an invitation's workspaces, in order. An id the viewer cannot
 * resolve (a workspace since deleted) shows as `#id` rather than vanishing.
 */
export function workspaceNames(
  ids: readonly number[],
  workspaces: ReadonlyArray<{ id: number; name: string }>
): string[] {
  const byId = new Map(workspaces.map((w) => [w.id, w.name]));
  return ids.map((id) => byId.get(id) ?? `#${id}`);
}
